import { Component, Input } from '@angular/core';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'bfv-messages',
  template: `
  <div class="mat-form-field-subscript-wrapper">
  <mat-error>
      <span *ngFor="let message of messages">{{message}}</span>
    </mat-error>
  </div>
  `
})
export class MessagesComponent {
  @Input()
  public messages: string[];

  get className() {
    return 'invalid-feedback';
  }

  constructor(
  ) { }
}
